module.exports = __webpack_public_path__ + "static/media/352.88ec80af.webp";